<script setup>
import HTitle from "~/components/seo/HTitle.vue"
import VideoItem from "~/components/partials/VideoItem.vue";

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const blockContent = computed(() => props.data.content)
const haveVSpacing = computed(() => blockContent.value.vSpacing)
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'mb-1': !haveVSpacing.value,
    'my-0': haveVSpacing.value,
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})
</script>

<template>
  <div v-if="blockContent" class="grid grid-cols-12 gap-1 bg-[#dcd6ce] pb-12" :class="containerClasses">
    <div class="col-span-12 px-8 lg:px-12">
      <HTitle v-if="blockContent.title" :type="blockContent.titleH" class="">
        {{
          blockContent.title
        }}
      </HTitle>
      <div v-if="blockContent.items.length > 0" class="grid grid-cols-12 gap-8">
        <client-only>
        <VideoItem v-for="video in blockContent.items" :key="video.id" :data="video"/>
        </client-only>
      </div>
      <div v-if="blockContent.description" class="text-justify" v-html="blockContent.description"></div>
    </div>
  </div>
</template>
